import { UPDATE_ARBEITSZEIT_TERMIN_VERKNUEPFUNG } from '@/domain/arbeitszeiten/hooks/graphql/mutation';
import {
  UpdateArbeitszeitTerminVerknuepfungMutation,
  UpdateArbeitszeitTerminVerknuepfungMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useArbeitszeitTerminVerknuepfungUpdate() {
  const [execute, result] = useMutation<
    UpdateArbeitszeitTerminVerknuepfungMutation,
    UpdateArbeitszeitTerminVerknuepfungMutationVariables
  >(UPDATE_ARBEITSZEIT_TERMIN_VERKNUEPFUNG, {
    refetchQueries: [
      'getArbeitszeitenByDateAndStandortId',
      'getArbeitszeitById',
      'GetToDos',
      'getTermineByDateAndStandortId',
    ],
    awaitRefetchQueries: true,
  });

  const arbeitszeitUpdate = useCallback(
    (variables: UpdateArbeitszeitTerminVerknuepfungMutationVariables) => {
      return execute({
        variables,
      });
    },
    [execute],
  );

  return [arbeitszeitUpdate, result] as const;
}
